import React from 'react';
import { useIntl } from 'react-intl';

import styles from './styles.module.scss';

export default function Description() {
  const intl = useIntl();
  return (
    <div className={styles.container}>
      <p className="big bold">
        {intl.formatMessage({
          id: 'controlpanel.orders.configuration.title'
        })}
      </p>
      <p>
        {intl.formatMessage({
          id: 'controlpanel.orders.configuration.description1'
        })}
      </p>
      <p>
        {intl.formatMessage({
          id: 'controlpanel.orders.configuration.description2'
        })}
      </p>
      <p
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({
            id: 'controlpanel.orders.configuration.description3'
          })
        }}
      />
    </div>
  );
}
